<template>
  <div>
    <v-row>
      <!-- <v-col cols="12" sm="12" md="4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text x-small v-bind="attrs" v-on="on" color="primary">
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn>
          </template>
          <span>Clear filter</span>
        </v-tooltip>
      </v-col> -->
      <v-col cols="12" sm="12" md="4">
        <filter-selection
          v-model="selectedMeetingTypes"
          :items="meetingTypesList"
        ></filter-selection>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <filter-selection
          v-model="selectedCategory"
          :items="categories"
          title="Agenda category"
        ></filter-selection>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <filter-selection
          v-model="selectedTopicCategory"
          :items="topicCategories"
          title="Topic category"
        ></filter-selection>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterSelection from "./FilterSelection.vue";
export default {
  name: "SideBarFilters",
  components: { FilterSelection },
  data() {
    return {
      selectedCategory: [],
      selectedMeetingTypes: [],
      selectedTopicCategory: [],
      topicCategories: [
        { name: "Approval", value: "A" },
        { name: "Special", value: "S" },
        { name: "Reporting", value: "R" },
      ],
    };
  },
  mounted() {
    this.topicCategories = this.tenantSettingTypes("topiccategory").sort(
      (a, b) => a.order - b.order
    );
  },
  computed: {
    ...gettersMap(),
    meetingTypesList() {
      return this.meetingTypes
        .filter((item) => {
          if (this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")) {
            return item;
          }
        })
        .map((type) => {
          return {
            name: type.label,
          };
        });
    },
  },
  watch: {
    selectedCategory() {
      this.$emit("applyFilter", {
        selectedCategory: this.selectedCategory,
        selectedMeetingTypes: this.selectedMeetingTypes,
        selectedTopicCategory: this.selectedTopicCategory,
      });
    },
    selectedMeetingTypes() {
      this.$emit("applyFilter", {
        selectedCategory: this.selectedCategory,
        selectedMeetingTypes: this.selectedMeetingTypes,
        selectedTopicCategory: this.selectedTopicCategory,
      });
    },
    selectedTopicCategory() {
      this.$emit("applyFilter", {
        selectedCategory: this.selectedCategory,
        selectedMeetingTypes: this.selectedMeetingTypes,
        selectedTopicCategory: this.selectedTopicCategory,
      });
    },
  },
};

function gettersMap() {
  return mapGetters({
    categories: "tenant/agendaCategories",
    meetingTypes: "tenant/agendaMeetingTypes",
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>

<style>
</style>